import CardTable from 'components/CardTable/CardTable'
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import AddIcon from "@material-ui/icons/Add";
import { columns } from './columns'
import {
  setComoDataFilters,
  resetComoDataSelected,
  addComoDataMode,
  getComoData,
  clearComoData,
} from 'redux/actions/comoData/comoDataActions'
import { Description } from '@material-ui/icons'
import RegularButton from 'components/CustomButtons/Button'
import { useSearch } from 'hooks/useSearch'
import { ModalV2 } from 'components/Modal/ModalV2'
import { FormComoDataEdit } from './FormComoDataEdit'
import { useValidateReload } from "hooks/useValidateReload";
import { TableInputs } from "components/CardTable/TableInputs";

const tableKey = "comoData";
const loadings = ["loadingComoData"];

export const ComoData = () => {
  const { setSnackbar, buildTableConfig } = useSearch();
  const { station, comoDataArr, addMode, deleteMode } = useSelector(state => state.comoData)
  const { isLoadingComp, configTables } = useSelector((state) => state.search);

  const [mapComoData, setComoData] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!station.id) {
      setSnackbar("No se ha seleccionado alguna planta.");
      return;
    }
    dispatch(getComoData(station.id));
  }

  const handleClose = () => {
    dispatch(resetComoDataSelected())
    setIsOpen(false)
  }

  const handleOpenAdd = () => {
    dispatch(addComoDataMode())
    setIsOpen(true)
  }

  useValidateReload(loadings);
  // Effects
  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, []);

  useEffect(() => {
    return () => dispatch(clearComoData())
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setComoData(
      comoDataArr?.map(comoData => {
        return {
          ...comoData,
          modal: setIsOpen,
        }
      }).flat()
    )
  }, [comoDataArr])

  useEffect(() => {
    const isEmpty = mapComoData.length === 0
    if (isEmpty && submitted) {
      setSnackbar("No se encontraron comoDatos");
    }
    setSubmitted(false);
    // eslint-disable-next-line
  }, [mapComoData])

  return (
    <React.Fragment>
      <CardTable
        hasHeader
        icon={<Description />}
        title="Comodatos"
        data={mapComoData}
        columns={columns}
        isLoading={isLoadingComp?.loadingComoData}
        blockBtn
        tableContent={
          <TableInputs
            reducer="comoData"
            stations
            dispatchAction={setComoDataFilters}
            submitLoadingKey="loadingComoData"
            submitAction={handleSubmit}
          />
        }
        hasControl
        controls={
          <RegularButton round justIcon color="info" onClick={handleOpenAdd}>
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      <ModalV2
        open={isOpen}
        title={addMode ? 'Agregar comodatos' : deleteMode ? '¿Estas seguro de eliminar estos comodatos?' : 'Modificar comodatos'}
        toRight
        onClose={handleClose}
        style={{ 'div': { border: '5px solid red', margin: 50 } }}
      >
        <FormComoDataEdit handleClose={handleClose} />
      </ModalV2>
    </React.Fragment>
  )
}
